//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    system
} from '../../api'
export default {
    methods: {
        hide() {
            this.$store.commit('updateDownLoad', false);
            localStorage.setItem('isDownLoad', 'false');

        },
        toDownLoad() {
            if (system() == 'ios') {
                window.location.href = 'https://itunes.apple.com/cn/app/快买酒/id1142862408?mt=8';
            } else {
                window.location.href = 'http://m.hackhome.com/XiaZai/SoftView_34928213.html';
            }
            // this.$router.push({
            //     name: 'downLoad'
            // })
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/DownLoad/DownLoad.vue